/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Partner_Admin_User_ActionsInputs */



/**
* | output |
* | --- |
* | "Actions for {email}" |
*
* @param {Partner_Admin_User_ActionsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_user_actions = /** @type {((inputs: Partner_Admin_User_ActionsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_User_ActionsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Aktionen für ${i?.email}`)
	return /** @type {LocalizedString} */ (`Actions for ${i?.email}`)
});